import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "/assets/img/logo-small.svg"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "caution-note" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_10 = { key: 3 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_12 = { key: 4 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("次"),
  /*#__PURE__*/_createElementVNode("rt", null, "つぎ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_15 = { key: 5 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("次"),
  /*#__PURE__*/_createElementVNode("rt", null, "つぎ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_18 = { key: 6 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("解答"),
  /*#__PURE__*/_createElementVNode("rt", null, "かいとう")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("時間"),
  /*#__PURE__*/_createElementVNode("rt", null, "じかん")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("分"),
  /*#__PURE__*/_createElementVNode("rt", null, "ぷん")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("間"),
  /*#__PURE__*/_createElementVNode("rt", null, "かん")
], -1)
const _hoisted_24 = { key: 7 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("解答"),
  /*#__PURE__*/_createElementVNode("rt", null, "かいとう")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("時間"),
  /*#__PURE__*/_createElementVNode("rt", null, "じかん")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("分"),
  /*#__PURE__*/_createElementVNode("rt", null, "ふん")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("間"),
  /*#__PURE__*/_createElementVNode("rt", null, "かん")
], -1)
const _hoisted_30 = { key: 8 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("解答"),
  /*#__PURE__*/_createElementVNode("rt", null, "かいとう")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("時間"),
  /*#__PURE__*/_createElementVNode("rt", null, "じかん")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("分"),
  /*#__PURE__*/_createElementVNode("rt", null, "ぷん")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("間"),
  /*#__PURE__*/_createElementVNode("rt", null, "かん")
], -1)
const _hoisted_36 = { key: 9 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("問題"),
  /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("解答"),
  /*#__PURE__*/_createElementVNode("rt", null, "かいとう")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("時間"),
  /*#__PURE__*/_createElementVNode("rt", null, "じかん")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("分"),
  /*#__PURE__*/_createElementVNode("rt", null, "ふん")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("間"),
  /*#__PURE__*/_createElementVNode("rt", null, "かん")
], -1)
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<p><ruby>答<rt>こた</rt></ruby>えがわかったら、その<ruby>番号<rt>ばんごう</rt></ruby>の◯を<ruby>押<rt>お</rt></ruby>してください。</p><p><ruby>間違<rt>まちが</rt></ruby>って<ruby>押<rt>お</rt></ruby>した<ruby>場合<rt>ばあい</rt></ruby>は、<ruby>正<rt>ただ</rt></ruby>しい<ruby>番号<rt>ばんごう</rt></ruby>の○を<ruby>押<rt>お</rt></ruby>しなおしてください。</p><p>リーディング<ruby>問題<rt>もんだい</rt></ruby>は、<ruby>自動<rt>じどう</rt></ruby>ですすみません。</p><p><ruby>次<rt>つぎ</rt></ruby>の<ruby>問題<rt>もんだい</rt></ruby>にすすむときは、<ruby>画面<rt>がめん</rt></ruby>の<ruby>一番右<rt>いちばんみぎ</rt></ruby>の、つぎへボタンを<ruby>押<rt>お</rt></ruby>してください。</p><p><ruby>前<rt>まえ</rt></ruby>の<ruby>問題<rt>もんだい</rt></ruby>に<ruby>戻<rt>もど</rt></ruby>りたいときは、<ruby>画面<rt>がめん</rt></ruby>の<ruby>一番<rt>いちばん</rt></ruby><ruby>左<rt>ひだり</rt></ruby>の、まえへボタンを<ruby>押<rt>お</rt></ruby>してください。</p>", 5)
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { key: 3 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("分"),
  /*#__PURE__*/_createElementVNode("rt", null, "ふん")
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("経"),
  /*#__PURE__*/_createElementVNode("rt", null, "た")
], -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("終"),
  /*#__PURE__*/_createElementVNode("rt", null, "お")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("画面"),
  /*#__PURE__*/_createElementVNode("rt", null, "がめん")
], -1)
const _hoisted_55 = { key: 10 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("終"),
  /*#__PURE__*/_createElementVNode("rt", null, "お")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("先生"),
  /*#__PURE__*/_createElementVNode("rt", null, "せんせい")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("言"),
  /*#__PURE__*/_createElementVNode("rt", null, "い")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("椅子"),
  /*#__PURE__*/_createElementVNode("rt", null, "いす")
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("座"),
  /*#__PURE__*/_createElementVNode("rt", null, "すわ")
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("静"),
  /*#__PURE__*/_createElementVNode("rt", null, "しず")
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("ruby", null, [
  /*#__PURE__*/_createTextVNode("待"),
  /*#__PURE__*/_createElementVNode("rt", null, "ま")
], -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("それでは、リーディング"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("問題"),
    /*#__PURE__*/_createElementVNode("rt", null, "もんだい")
  ]),
  /*#__PURE__*/_createTextVNode("を"),
  /*#__PURE__*/_createElementVNode("ruby", null, [
    /*#__PURE__*/_createTextVNode("始"),
    /*#__PURE__*/_createElementVNode("rt", null, "はじ")
  ]),
  /*#__PURE__*/_createTextVNode("めてください。")
], -1)

import {ref, inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { appKey, examKey } from "@/main";
import DemoControl from "@/components/parts/DemoControl.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadingCaution',
  emits: ['overridePageName'],
  setup(__props) {

const route = useRoute();
const router = useRouter();

const app = inject(appKey);
const exam = inject(examKey);


const baseUrl = exam?.getAudioUrl();
const group = route.params.group;
const rank = ref<string>('');
const gakken = exam?.isGakken();

const playCaution = async () => {
  app?.playAudioUrl(baseUrl + 'caution_reading_' + rank.value + '.m4a', false, async () => {
    if (!gakken) {
      await playCautionTeacher();
    }
    else {
      await playCautionStart();
    }
  })
}

const playCautionTeacher= async () => {
  app?.playAudioUrl(baseUrl + 'caution_reading_teacher.m4a', false, async() => {
    await playCautionStart();
  });
}

const playCautionStart = async () => {
  app?.playAudioUrl(baseUrl + 'caution_reading_start.m4a', false, async () => {
    await next();
  });
}

const init = async () => {
  if (!exam) return;
  rank.value = (await exam.questions()).rank;
  app?.unsetAudioEndedEventListener();
  await playCaution();
}
init();

const next = async() => {
  await exam?.readingStart();
  router.replace(`/cbt/${group}/reading/0/flow`)
}

const demoPrev = async () => {
  if (!exam) return;
  app?.stopAudio();
  const questions = await exam.questions();
  const page = questions.listening.pages.length - 1;
  router.replace(`/cbt/${group}/listening/${page}`);
}
const demoNext = () => {
  app?.stopAudio();
  next();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "m-logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exam).isDebug() && next()))
    }, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        (rank.value === '1-2')
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createTextVNode("Part 1からPart 5までのリスニング"),
              _hoisted_5,
              _createTextVNode("はここまでです。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '3-4')
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createTextVNode("Part 1からPart 5までのリスニング"),
              _hoisted_7,
              _createTextVNode("はここまでです。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '5-6')
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
              _createTextVNode("Part 1からPart 5までのリスニング"),
              _hoisted_9,
              _createTextVNode("はここまでです。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '7-8')
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
              _createTextVNode("Part 1からPart 6までのリスニング"),
              _hoisted_11,
              _createTextVNode("はここまでです。")
            ]))
          : _createCommentVNode("", true),
        (rank.value !== '7-8')
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
              _hoisted_13,
              _createTextVNode("からは、リーディング"),
              _hoisted_14,
              _createTextVNode("です。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '7-8')
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
              _hoisted_16,
              _createTextVNode("は、リーディング"),
              _hoisted_17,
              _createTextVNode("です。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '1-2')
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
              _createTextVNode("Part 6からPart8までの"),
              _hoisted_19,
              _createTextVNode("の"),
              _hoisted_20,
              _hoisted_21,
              _createTextVNode("は、20"),
              _hoisted_22,
              _hoisted_23,
              _createTextVNode("です。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '3-4')
          ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
              _createTextVNode("Part 6からPart8までの"),
              _hoisted_25,
              _createTextVNode("の"),
              _hoisted_26,
              _hoisted_27,
              _createTextVNode("は、15"),
              _hoisted_28,
              _hoisted_29,
              _createTextVNode("です。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '5-6')
          ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
              _createTextVNode("Part 6とPart7の"),
              _hoisted_31,
              _createTextVNode("の"),
              _hoisted_32,
              _hoisted_33,
              _createTextVNode("は、10"),
              _hoisted_34,
              _hoisted_35,
              _createTextVNode("です。")
            ]))
          : _createCommentVNode("", true),
        (rank.value === '7-8')
          ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
              _createTextVNode("Part 7の"),
              _hoisted_37,
              _createTextVNode("の"),
              _hoisted_38,
              _hoisted_39,
              _createTextVNode("は、5"),
              _hoisted_40,
              _hoisted_41,
              _createTextVNode("です。")
            ]))
          : _createCommentVNode("", true),
        _hoisted_42,
        _createElementVNode("p", null, [
          (rank.value === '1-2')
            ? (_openBlock(), _createElementBlock("span", _hoisted_47, "20"))
            : _createCommentVNode("", true),
          (rank.value === '3-4')
            ? (_openBlock(), _createElementBlock("span", _hoisted_48, "15"))
            : _createCommentVNode("", true),
          (rank.value === '5-6')
            ? (_openBlock(), _createElementBlock("span", _hoisted_49, "10"))
            : _createCommentVNode("", true),
          (rank.value === '7-8')
            ? (_openBlock(), _createElementBlock("span", _hoisted_50, "5"))
            : _createCommentVNode("", true),
          _hoisted_51,
          _hoisted_52,
          _createTextVNode("ったら、テストはこれで"),
          _hoisted_53,
          _createTextVNode("わりですという"),
          _hoisted_54,
          _createTextVNode("になります。 ")
        ]),
        (!_unref(gakken))
          ? (_openBlock(), _createElementBlock("p", _hoisted_55, [
              _createTextVNode("テストが"),
              _hoisted_56,
              _createTextVNode("わったら"),
              _hoisted_57,
              _createTextVNode("がよいと"),
              _hoisted_58,
              _createTextVNode("うまで、"),
              _hoisted_59,
              _createTextVNode("に"),
              _hoisted_60,
              _createTextVNode("ったまま"),
              _hoisted_61,
              _createTextVNode("かに"),
              _hoisted_62,
              _createTextVNode("ちましょう。")
            ]))
          : _createCommentVNode("", true),
        _hoisted_63
      ])
    ]),
    _createVNode(DemoControl, {
      onPrev: demoPrev,
      onNext: demoNext
    })
  ], 64))
}
}

})